import { atom } from 'jotai';

export const selectedAssetsAtom = atom<string[]>([]);
